const usePermissionConfig = () => {
  return {
    // 添加
    TJ: 'OPS-JKZX-REDIS-TJ',
    // 删除
    SC: 'OPS-JKZX-REDIS-SC',
    // 修改键
    XGJ: 'OPS-JKZX-REDIS-XGJ',
    // 修改值
    XGZ: 'OPS-JKZX-REDIS-XGZ',
    // 修改TTL
    XGTTL: 'OPS-JKZX-REDIS-XGTTL',
  };
};

export default usePermissionConfig;
